import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { athlete } from "@/data/athlete";

const SECTIONS = [
  { id: "hero", label: "Overview" },
  { id: "film", label: "Film" },
  { id: "stats", label: "Stats" },
  { id: "team", label: "Team" },
  { id: "events", label: "Events" },
  { id: "academics", label: "Academics" },
  { id: "profiles", label: "Profiles" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="site-nav"
      className={`sticky top-0 z-50 backdrop-blur-xl transition-colors ${
        scrolled ? "bg-black/80" : "bg-black/40"
      } border-b border-white/10`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <button
          onClick={() => go("hero")}
          data-testid="nav-brand"
          className="font-display text-xl tracking-tight text-white uppercase hover:text-[#FF3B30] transition-colors"
        >
          {athlete.firstName} {athlete.lastName}{" "}
          <span className="text-[#FF3B30]">#{athlete.jerseyNumber}</span>
        </button>

        <div className="hidden md:flex items-center gap-7">
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              data-testid={`nav-link-${s.id}`}
              onClick={() => go(s.id)}
              className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-400 hover:text-white transition-colors"
            >
              {s.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-white/10 bg-black/95"
        >
          <div className="px-4 py-4 grid grid-cols-2 gap-3">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                data-testid={`nav-mobile-link-${s.id}`}
                onClick={() => go(s.id)}
                className="text-left text-xs uppercase tracking-[0.2em] font-bold text-zinc-300 hover:text-[#FF3B30] py-2"
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
